import { FC } from "react";
import Container from "@/components/Container";
import useMediaQuery from "@/custom_hooks/mediaQuery";
import ROUTES from "@/data/Routes";
import HealthProblems from "@/components/HealthProblems/HealthProblems";
import FAQSection from "@/components/FAQSection";
import mainImg from "@/assets/images/aboutUs/main.png";
import mainMobImg from "@/assets/images/aboutUs/main.png";
import starIcon from "@/assets/icons/aboutus-star.svg";
import lighthouseIcon from "@/assets/icons/lighthouse.svg";
import { ActionLink } from "@/components/UI/Buttons";
import { COLLAPSABLE_CONTENT_HOME_FAQ_VALUES } from "@/components/Collapsible/constants";

const AboutUs: FC = () => {
  const isMobile = useMediaQuery(768);

  return (
    <div className="flex w-full flex-col bg-white">
      {/* Top Section */}
      <section className="flex flex-col px-4 pt-25 md:px-6 md:pt-50">
        <Container>
          <div className="flex flex-col items-center gap-7.5 md:gap-12.5">
            <h1 className="text-ink md:text-heading-1-md text-center text-3xl font-light">
              New Health Elite™
            </h1>
            <div className="text-muted flex flex-col gap-5 text-center text-base md:w-4/5 md:text-lg">
              <p>
                Telomera tarnauja naujajam sveikatos elitui - žmonėms,
                siekiantiems racionaliai kontroliuoti savo sveikatą
              </p>
              <p>
                Atlikdami patikimiausius diagnostinius tyrimus, mes kuriame
                personalizuotus ilgaamžiškumo protokolus bei padedame
                dramatiškai pagerinti gyvenimo kokybę ir trukmę.
              </p>
              <p>Investuokite į save ir tapkite vienu iš mūsų!</p>
            </div>
          </div>

          <img
            src={isMobile ? mainMobImg : mainImg}
            alt="Clinic"
            className="mt-7.5 w-full rounded-[20px] md:mt-12.5 md:rounded-[22px]"
          />
        </Container>
      </section>

      {/* Founders Section */}
      <section className="flex flex-col px-4 py-7.5 md:px-6">
        <Container>
          <div className="flex flex-col gap-7.5 md:items-center">
            <div className="flex flex-col gap-7.5 md:flex-1 md:flex-row">
              <div className="rounded-card bg-surface flex flex-1 flex-col justify-between gap-5 p-5">
                <div className="border-grey-stroke flex h-10 w-10 items-center justify-center rounded-[10px] border">
                  <img src={lighthouseIcon} alt="Vision" className="h-6 w-6" />
                </div>
                <div className="flex flex-col gap-2">
                  <h3 className="text-ink text-base font-normal">
                    Mūsų vizija
                  </h3>
                  <p className="text-muted text-base leading-relaxed">
                    Mes matome ateitį, kurioje žmogaus sveikata nėra genetinė
                    loterija, o moksliškai suprojektuotas ir valdomas procesas.
                    Mes keičiame reaktyvų gydymą (gydymas tik susirgus) į
                    suprojektuotą ilgaamžiškumą.
                  </p>
                </div>
              </div>

              <div className="rounded-card bg-surface flex flex-1 flex-col justify-between gap-5 p-5">
                <div className="border-grey-stroke flex h-10 w-10 items-center justify-center rounded-[10px] border">
                  <img src={starIcon} alt="Mission" className="h-6 w-6" />
                </div>
                <div className="flex flex-col gap-2">
                  <h3 className="text-ink text-base font-normal">
                    Mūsų misija
                  </h3>
                  <p className="text-muted text-base leading-relaxed">
                    Įgalinti naująjį sveikatos elitą valdyti savo ateitį.
                    Naudodami giliausius klinikinius duomenis, kuriame
                    individualias programas, kurios dramatiškai prailgina
                    kokybiško gyvenimo trukmę.
                  </p>
                </div>
              </div>
            </div>

            <ActionLink
              to={ROUTES.TEAM}
              variant="light"
              className="border-grey-stroke h-[63px] w-auto rounded-[75px] border"
              showIcon={false}
              onHover
              hoverDark
            >
              Susipažinti su visa komanda
            </ActionLink>
          </div>
        </Container>
      </section>

      {/* Health Problems (MRI) Section */}
      <HealthProblems />

      {/* FAQ Section */}
      <FAQSection
        data={COLLAPSABLE_CONTENT_HOME_FAQ_VALUES.items}
        variant="white"
      />
    </div>
  );
};

export default AboutUs;
